import React, {useState, useEffect} from 'react';
import moment from 'moment';

import VIDABOO_CONSTANTS from '../../../../../../../../../../config/consts';

import './threeDWidgetComponent.css';

const ThreeDRow = (props) => {
  const {selectedFile} = props;
  const [fileSize, setFileSze] = useState('');

  useEffect(() => {
    const size = bytesToSize(props.threeDFile.fileSize);
    setFileSze(size);
  }, [props.threeDFile?.fileSize]);
  const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    // return parseFloat((bytes / Math.pow(1024, i)).toFixed(1)) + ' ' + sizes[i];
  };
  // const downloadFile = (threeDFile) => {
  //   console.debug('downloadFiledownloadFile', threeDFile);
  // };
  return (
    <>
      <div
        className={'et-3d-visit-row'}
        key={1}
        onClick={() => props.onClick3DFile(props.threeDFile)}>
        <span
          className={
            selectedFile &&
            selectedFile.threedFileId === props.threeDFile.threedFileId
              ? 'et-3d-row-right et-3d-row-right-selected'
              : 'et-3d-row-right'
          }>
          <div className="et-3d-row-img-wrap">
            <img
              src={
                VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
                props.threeDFile.tempThumbnailUrl
              }
              alt="thumb"
            />
          </div>
          <div className="et-3d-file-name">{props.threeDFile.fileName}</div>
          {props.type !== 'chat' && (
            <>
              <div>
                <div className="et-3d-date-time">
                  <span className="et-3d-row-span">
                    {moment(new Date(props.threeDFile.creationTime)).format(
                      'DD-MM-YYYY',
                    )}
                  </span>
                </div>
              </div>
              <div className="et-3d-file-size">{fileSize}</div>
              <div className="et-3d-file-size">
                <a
                  href={
                    VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
                    `${props.threeDFile.tempAccessibleUrl}`
                  }
                  download>
                  Download
                </a>
              </div>
            </>
          )}
        </span>
      </div>
    </>
  );
};
export default ThreeDRow;
